// Updated notification preference utility functions
export const PREF_KEY = "notification_prompt_preference";

export function getUserNotificationPreference(): "granted" | "denied" | null {
    const notificationSupported = "Notification" in window;
    if (typeof window === "undefined" || !notificationSupported) return null;

    const actualPermission = Notification.permission;
    const storedPref = localStorage.getItem(PREF_KEY) as "granted" | "denied" | null;

    // If browser permission is "default" but we have a stored preference of "denied",
    // it means user previously declined our custom prompt (not browser prompt)
    if (actualPermission === "default" && storedPref === "denied") {
        return "denied"; // Don't clear localStorage, respect user's choice
    }

    // If browser permission changed from stored preference, sync them
    if (actualPermission !== "default" && storedPref !== actualPermission) {
        localStorage.setItem(PREF_KEY, actualPermission);
        return actualPermission;
    }

    // If browser permission is "default" and no stored preference, return null (show prompt)
    if (actualPermission === "default" && !storedPref) {
        return null;
    }

    return storedPref;
}

export function setUserNotificationPreference(pref: "granted" | "denied" | "default"){
    if (typeof window === "undefined") return;
    localStorage.setItem(PREF_KEY, pref);
}
